import { React, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from '../../../components/User_Context.js';
import * as api from "../../../api/apiConnector.js";
import * as menu from "../../../assets/menus/menu.js";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';

function DMS_Scraper_Screen(params) {
    const { id = null } = useParams();
    const { currentUser } = useContext(UserContext);
    let system_message_timer = null;
    const [url, setUrl] = useState("");
    const [followLinks, setFollowLinks] = useState(false);
    const [scraping, setScraping] = useState(false);
    const { t } = useTranslation('labels');
    //#region chat
    const _parseMessage = (message) => {

        switch (message.type) {
            case "stopping": {
                window.document.location.href = '/';
            }
                break;
            case "still_there": {
                withReactContent(Swal).fire({
                    title: t('stillThere', { ns: 'labels' }),
                    icon: "question",
                    text: t('stillThereQuestion', { ns: 'labels' }),
                    showConfirmButton: true,

                }).then(async (result) => {
                    if (result.isConfirmed) {
                        _sendMessage({
                            type: "ping"
                        });
                    } else {
                        window.document.location.href = '/';
                    }
                });
            }
                break;
            case "scrape_ended": {
                window.location.href = `/dms/${id}`;
            }
                break;
            case "page_scraped": {
                show_system_message({
                    message: `${message.url}`,
                    timeOut: 0
                });

                window.$("#scraper_image").attr("src", message.picture);
            }
                break;
            case "wellcome": {
                window.client.id = message.id;
                _sendMessage({
                    type: "authenticate",
                    token: currentUser().token,
                    parentId: id
                });

                show_system_message({
                    timeOut: 0,
                    message: `
                        <strong>${t('connectingToApi', { ns: 'labels' })}</strong>...
                        `});
            }
                break;
            case "authenticated": {
                window.$("#scraper_input").prop("hidden", null);


                show_system_message({
                    message: `
                        <strong>${t('connected', { ns: 'labels' })}</strong>...
                        `});
            }
                break;
        }
    }

    const _sendMessage = async (message) => {
        if (window.client?.id) {
            message.id = window.client.id;
        }

        var result = await api.sendMessage("scraper/message", {
            user: currentUser(),
            body: {
                message
            }
        });

        window.$("#current-question-text").text(message.query);
    }

    const show_system_message = (params) => {
        const { message, timeOut = 2000 } = params;

        const inner_div = window.$(`<div class="col-xl-12">
                <div class="card dz-card">
                    <div class="card-header flex-wrap border-0">
                        <div>
                            <h4 class="card-title">AI Plan</h4>
                        </div>											
                    </div>
                    <div class="tab-content">
                        <div class="tab-pane fade active show" role="tabpanel">
                            <div class="card-body pt-0">
                                <h6><span></span>
                                    <span class="pull-end"></span>
                                </h6>                                                                        
                            </div>
                        </div>
                    </div>
        
                </div>
            </div>`);

        let div = window.$("#chat-system-message");

        if (div.length == 0) {
            div = window.$(`<div id="chat-system-message" style="position: fixed; right: 20px; bottom: 30px; width: 350px; height: 100px; opacity: 0.75"></div>`);
            window.$("body").append(div);
            div.append(inner_div);
        }

        const message_div = div.find(".pull-end");


        message_div.html("");
        message_div.append(window.$("<div/>").html(message));

        if (system_message_timer) {
            clearTimeout(system_message_timer);
        }

        if (timeOut > 0) {
            system_message_timer = setTimeout(() => {
                div.remove();
            }, timeOut);
        }
    }

    const startChat = async () => {
        if (!window.client) {
            const _client = new window.EventSource(`${process.env.REACT_APP_API_URL}/scraper/init`);
            _client.onmessage = (e) => {
                _parseMessage(JSON.parse(e.data));
            }

            window.client = {
                emitter: _client,
                html: ""
            }

            return _client;
        }
    }
    //#endregion

    useEffect(() => {
        (async () => {
            menu.write({ user: currentUser() });

            startChat();

        })();
    }, []);

    const _inner_div = () => {
        return (<div id="scraper_input" hidden>
            {scraping ? _scraping_div() : _url_div()}
        </div>);
    }

    const _scraping_div = () => {
        return (<div>
            <div style={{ textAlign: "right" }}>
                <button type="submit" class="btn btn-danger" onClick={(e) => {
                    _sendMessage({
                        type: "stop"
                    });
                    setScraping(false);
                }}>{t('stop', { ns: 'labels' })}</button>
            </div>
            <hr></hr>
            <div class="row" style={{ width: "100%", textAlign: "center" }}>
                <img id="scraper_image" style={{ maxWidth: 450, maxHeight: 450 }}></img>
            </div>
        </div>);
    }

    const _url_div = () => {
        return (<>
            <div className="mb-3">
                <label for="url_box" className="form-label">{t('pageUrl', { ns: 'labels' })}</label>
                <input type="text" className="form-control" id="url_box" aria-describedby="url_box_help" value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                    }} />
                <div id="url_box_help" className="form-text">{t('urlScraped', { ns: 'labels' })}</div>
            </div>
            <div className="mb-3 form-check">
                <input type="checkbox" className="form-check-input" id="follow_links_check" checked={followLinks} onChange={(e) => {
                    setFollowLinks(window.$(e.target).is(":checked"));
                }} />
                <label class="form-check-label" for="follow_links_check" >{t('followPage', { ns: 'labels' })}</label>
            </div>
            <button type="submit" class="btn btn-primary" onClick={(e) => {
                _sendMessage({
                    type: "scrape",
                    url: url,
                    followLinks: followLinks
                });
                setScraping(true);
            }}>{t('start', { ns: 'labels' })}</button>
        </>);
    }

    return (<>
        <div class="page-titles">
            <ol className="breadcrumb">
            </ol>
        </div>
        <div className="container-fluid">
            <div className="row">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body "></div>
                        <div class="active-projects task-table table-responsive">
                            <div class="tbl-caption">
                                <h4 class="heading mb-0">{t('wwwScraper', { ns: 'labels' })}</h4>
                                <small>{t('aiPoweredScraper', { ns: 'labels' })}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body p-0"></div>
                        <div class="table-responsive active-projects task-table">
                            <div class="tbl-caption">
                                <h4 class="heading mb-0">{t('readyToScrape', { ns: 'labels' })}</h4>
                                {_inner_div()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export { DMS_Scraper_Screen };